import React, { useState, useRef } from 'react';
import { AuthLayout } from '../../../components/AuthLayout';
import Logo from '../../../assets/images/logo.png';
import { useMobile } from '../../../hooks/useMobile';

export const VerifyAccount = () => {
    const [otp, setOtp] = useState(new Array(6).fill(""));
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);
    const isMobile = useMobile();

    const handleChange = (element: HTMLInputElement, index: number) => {
        if (isNaN(Number(element.value))) return false;

        setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

        if (element.value !== "" && index < 5) {
            inputRefs.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>, index: number) => {
        if (e.key === "Backspace" && index > 0 && !otp[index]) {
            inputRefs.current[index - 1]?.focus();
        }
    };

    const containerStyle: React.CSSProperties = {
        width: isMobile ? '95%' : '70%',
        backgroundColor: '#fff',
        margin: '40px auto',
        borderRadius: '20px',
        boxShadow: '0px 4px 24px 0px #00000040',
        padding: '40px 30px',
        textAlign: 'center',
        fontFamily: 'Manrope, sans-serif'
    };

    const otpInputStyle: React.CSSProperties = {
        width: isMobile ? '40px' : '50px',
        height: isMobile ? '45px' : '55px',
        margin: '0 5px',
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: '600',
        borderRadius: '8px',
        backgroundColor: '#F3F4F6',
        outline: 'none',
        border: '1px solid #4B556333'
    };

    return (
        <AuthLayout directory="/signup" showBackLink={true}>
            <div style={containerStyle}>
                <img src={Logo} alt="Logo" style={{ width: '40%' }} />
                
                <h1 style={{ fontSize: '24px', fontWeight: '700', margin: '40px 0px 10px', color: '#1F2933' }}>
                    Verify Your Account
                </h1>
                <p style={{ fontSize: '14px', color: '#6B7280', marginBottom: '30px' }}>
                    We sent a 6-digit code to c***@gmail.com
                </p>

                <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '40px' }}>
                    {otp.map((data, index) => (
                        <input
                            key={index}
                            type="text"
                            maxLength={1}
                            style={otpInputStyle}
                            value={data}
                            onChange={(e) => handleChange(e.target, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => {
                                inputRefs.current[index] = el;
                            }}
                        />
                    ))}
                </div>

                <button
                    style={{
                        width: '100%',
                        padding: '16px',
                        backgroundColor: '#1A2238',
                        color: 'white',
                        border: 'none',
                        borderRadius: '12px',
                        fontSize: '18px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        marginBottom: '20px'
                    }}
                >
                    Verify
                </button>

                <p 
                    style={{ color: '#D4AF37', fontWeight: '600', cursor: 'pointer', fontSize: '14px' }}
                    onClick={() => console.log("Resend code logic")}
                >
                    Resend Code
                </p>
            </div>
        </AuthLayout>
    );
};